module.exports = __webpack_public_path__ + "img/hospitality.d4a56497.png";